<app-main-dialog (dismiss)="dismiss()">
  <div desktopTitle>

  </div>
  @if (imageElementS()) {
    @if (pointS()) {
      <app-area-map [point]="pointS()"
        [imgElement]="imageElementS()"></app-area-map>
    } @else if (pointsS()?.length > 0) {
      <app-fabric [imgElement]="imageElementS()"
        [points]="pointsS()"
        [disabled]="true"></app-fabric>
    }
  }
</app-main-dialog>